// The first-login guided tour for the new Insights answer UI. Built on driver.js
// (tiny spotlight/popover tour). The driver.css + brand overrides live in index.css
// (scoped to the `insight-tour` popover class) so this module stays style-free and
// easy to unit-test. The steps target the stable `data-tour` hooks in
// InsightToggleView (the toggle, the visual view, the Text Analysis tab).

import { driver, type Config, type Driver } from 'driver.js';

export const INSIGHT_TOUR_STEPS: NonNullable<Config['steps']> = [
  {
    element: '[data-tour="insights-toggle"]',
    popover: {
      title: 'Two ways to read every answer',
      description:
        'Switch between Insights — the new visual report — and Text Analysis, the full written answer. Your choice, any time.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="insights-view"]',
    popover: {
      title: 'Insights — the visual report',
      description:
        'The headline answer, key numbers, prevalence bars and quotes, laid out for fast reading.',
      side: 'top',
      align: 'start',
    },
  },
  {
    element: '[data-tour="text-analysis-tab"]',
    popover: {
      title: 'Text Analysis — the full write-up',
      description:
        "Prefer the complete prose answer with every quote? It's one tap away — nothing is lost.",
      side: 'bottom',
      align: 'start',
    },
  },
];

// Start the tour; `onDone` fires once when it ends (finished, skipped, or closed).
export function startInsightTour(onDone?: () => void): Driver {
  const d = driver({
    showProgress: true,
    progressText: '{{current}} of {{total}}',
    nextBtnText: 'Next',
    prevBtnText: 'Back',
    doneBtnText: 'Got it',
    overlayOpacity: 0.55,
    stagePadding: 6,
    stageRadius: 10,
    popoverClass: 'insight-tour',
    steps: INSIGHT_TOUR_STEPS,
    onDestroyed: () => {
      onDone?.();
    },
  });
  d.drive();
  return d;
}
